import { DivineControlEventManager } from "../Events/DivineControlsEventManager.js";
import { DivineControls } from "../DivineControls.js";
class DivineGamepad {
    gamepad;
    static BINDINGS = {
        XBOX360: [
            "A",
            "B",
            "X",
            "Y",
            "LB",
            "RB",
            "Left Trigger",
            "Right Trigger",
            "Back",
            "Start",
            "Left Analog In",
            "Right Analog In",
            "DPad Up",
            "DPad Down",
            "DPad Left",
            "DPad Right",
        ],
    };
    bindings;
    pressed = {};
    axes;
    constructor(gamepad) {
        this.gamepad = gamepad;
        for (const button of DivineGamepad.BINDINGS.XBOX360) {
            this.pressed[button] = false;
        }
        this.bindings = DivineGamepad.BINDINGS.XBOX360;
    }
    _axes1 = [0, 0];
    _axes2 = [0, 0];
    _testAxes(value) {
        return (value * 100) >> 0;
    }
    update() {
        const gp = navigator.getGamepads()[this.gamepad.index];
        if (this._testAxes(gp.axes[0]) || this._testAxes(gp.axes[1])) {
            const control = DivineControls._gamePadStickInputs.get("Left");
            if (control) {
                const dcEvent = (DivineControlEventManager.getEvent("gamepad-axes-move"));
                dcEvent.axes[0] = gp.axes[0];
                dcEvent.axes[1] = gp.axes[1];
                control.action(dcEvent.setData(control.input["gamepad-axes"]));
            }
        }
        if (this._testAxes(gp.axes[2]) || this._testAxes(gp.axes[3])) {
            const control = DivineControls._gamePadStickInputs.get("Right");
            if (control) {
                const dcEvent = (DivineControlEventManager.getEvent("gamepad-axes-move"));
                dcEvent.axes[0] = gp.axes[2];
                dcEvent.axes[1] = gp.axes[3];
                control.action(dcEvent.setData(control.input["gamepad-axes"]));
            }
        }
        for (let i = 0; i < gp.buttons.length; i++) {
            //   if (!this.bindings[i]) continue;
            const button = gp.buttons[i];
            if (button.pressed) {
                if (!this.pressed[this.bindings[i]]) {
                    const control = DivineControls._gamePadInputs.down.get(this.bindings[i]);
                    if (control) {
                        const dcEvent = DivineControlEventManager.getEvent("gamepad-botton-down");
                        control.action(dcEvent.setData(control));
                    }
                }
                this.pressed[this.bindings[i]] = true;
            }
            else {
                if (this.pressed[this.bindings[i]]) {
                    const control = DivineControls._gamePadInputs.up.get(this.bindings[i]);
                    if (control) {
                        const dcEvent = DivineControlEventManager.getEvent("gamepad-botton-up");
                        control.action(dcEvent.setData(control));
                    }
                }
                this.pressed[this.bindings[i]] = false;
            }
        }
    }
}
export { DivineGamepad };
